export default [{
  path: '/project/:pid',
  name: 'ProjectFullLayout',
  props: true,
  component: () =>
    import(
      /* webpackChunkName: "pc-base" */ `@/components/pc/ProjectFullLayout`
    ),
  children: [{
    path: '404',
    name: 'Project404',
    component: () => import(/* webpackChunkName: "pc-base" */ `@/pc/organization/Project-404`)
  }]
}]
